<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 v-if="client && client.key && site && site.key" class="p-d-flex p-ai-baseline">
                    <router-link icon="pi pi-angle-left" class="p-button p-button-icon p-mr-4"
                        :to="{ name: 'asset', params: { client_id: client.key, site_id: site.key, id: asset.key } }">
                        <i class="pi pi-angle-left"></i>
                        Back
                    </router-link>
                    <span>
                        <router-link :to="{ name: 'sites', params: { id: client.key } }">{{ client.name }}</router-link> /
                        <router-link :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">
                            {{ site.name }}
                        </router-link> /
                        <router-link
                            :to="{ name: 'asset', params: { client_id: client.key, site_id: site.key, id: asset.key } }">Asset
                            #{{ asset.asset_id }}
                        </router-link> /
                        Notes
                    </span>
                </h4>

                <div class="p-d-flex p-jc-end p-mb-2" v-if="assetNotes.length > 5">
                    <Button label="New Note" icon="pi pi-plus" class="p-button-secondary"
                        @click="note = {}; editingNote = true" iconPos="right" />
                </div>
                <Panel :header="format_date(assetNote.timestamp)" v-for="assetNote in orderBy(assetNotes, 'timestamp', -1)"
                    :key="assetNote.id" class="p-mb-3">
                    <div v-if="assetNote.type == 'text' || assetNote.type == 'task'">
                        <p v-html="assetNote.content.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2')"></p>
                    </div>

                    <div v-if="assetNote.type == 'photo'">
                        <img style="max-width: 200px;max-height: 200px;" :src="assetNote.content" />
                    </div>

                    <p v-if="assetNote.type == 'checklist'">
                        <span v-for="(content, index) in assetNote.content" :key="index">
                            <span v-if="index > 0 && index <= assetNote.content.length"> | </span>
                            <span>{{ content.name }}</span>
                            <b v-if="content.complete == true"> - Complete </b>
                            <b v-if="content.complete == false"> - Complete </b>
                        </span>
                    </p>
                </Panel>
                <div v-if="assetNotes.length < 1">
                    <p class="p-jc-center">There are 0 notes assigned to this site yet. Click a 'New Note' to add a
                        note.</p>
                </div>

                <div class="p-d-flex p-jc-end">
                    <Button label="New Note" icon="pi pi-plus" class="p-button-secondary"
                        @click="note = {}; editingNote = true" iconPos="right" />
                        <Dialog :visible.sync="editingNote">
                        <template #header>
                            <h3>Add Note</h3>
                        </template>

                        <Textarea v-model="note.content" rows="5" cols="30" />

                        <template #footer>
                            <Button label="Cancel" icon="pi pi-times" class="p-button-text"
                                @click="note = {}; editingNote = false" />
                            <Button label="Save" icon="pi pi-check" @click="addEditNote(note)" />
                        </template>
                    </Dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '@/firebase';
import Vue2Filters from 'vue2-filters';
import moment from 'moment';

export default {
    props: ['user'],
    mixins: [Vue2Filters.mixin],
    data() {
        return {
            client: {},
            site: {},
            assetNotes: [],
            siteTasks: [],
            editingNote: false,
            selected: {
                name: '',
            },
            displayConfirmation: false,
            note: {
                content: '',
            },
        }
    },
    firestore() {
        return {
            assetNotes: db.collection('asset_notes').where('client_id', '==', this.$route.params.client_id).where('asset_id', '==', this.$route.params.asset_id),
            notes: db.collection('asset_notes'),
            site: db.collection('sites').doc(this.$route.params.id),
            client: db.collection('clients').doc(this.$route.params.client_id),
            asset: db.collection('assets').doc(this.$route.params.asset_id),
        }
    },
    methods: {
        format_date(value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY @ hh:mma')
            }
        },
        createTask() {
            const task = {
                timestamps: {
                    created: Date.now()
                },
                name: this.selected.name,
                site_id: this.site.key,
                status: 'active',
            }
            this.$firestore.tasks.add(task).then(() => {
                this.selected.name = '';
                this.visibleRight = false;
                db.collection('logs').add({
                    activity: 'New task created',
                    timestamp: new Date(),
                    user: this.user.email,
                    client_id: this.user.client.key
                }).then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'New task created', life: 3000 });
                });
            });
        },
        addEditNote: function (note) {
            if (note.key) {
                this.$firestore.notes.doc(note.key).update({ 'content': this.note.content }).then(() => {
                    this.editingNote = false;
                    db.collection('logs').add({
                        activity: 'Note updated',
                        timestamp: new Date(),
                        user: this.user.email,
                        client_id: this.user.client.key
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Note updated', life: 3000 });
                    });
                });
            } else {
                this.$firestore.notes.add({ 'site_id': this.site.key, 'client_id': this.$route.params.client_id, 'asset_id': this.$route.params.asset_id, 'type': 'text', 'content': note.content, 'timestamp': Date.now() }).then(() => {
                    this.editingNote = false;
                    db.collection('logs').add({
                        activity: 'Note added',
                        timestamp: new Date(),
                        user: this.user.email,
                        client_id: this.user.client.key
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Note added', life: 3000 });
                    });
                });
            }
        },
    }
}
</script>

<style scoped lang="scss">
.p-datatable-row-expansion {
    td {
        padding: 0;
    }
}
</style>
